import { render, staticRenderFns } from "./mode.vue?vue&type=template&id=a367c522&"
import script from "./mode.vue?vue&type=script&lang=js&"
export * from "./mode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports